export const createNotSupportedError = () => new DOMException('', 'NotSupportedError');